<template>
  <div class="transition-all">
    <div
      :class="
        'sidebar transition-all shadow-lg ' +
          (readingExperience.index ? 'sidebar-show' : 'sidebar-hide')
      "
    >
      <div class="d-flex justify-content-center flex-column p-3">
        <div class="row d-flex align-items-center m-2 mt-4">
          <div class="col-md-2">
            <button
              class="btn br-button-primary text-white shadow-lg border-radius-2 d-flex align-items-center justify-content-center"
              @click="hide"
            >
              <i class="fas fa-chevron-left fa-2x"></i>
            </button>
          </div>
          <div class="col-md-8">
            <h1 class="text-center">
              Indice
            </h1>
          </div>
        </div>
        <div class="sidebar-panel">
          <br-index-item
            v-for="(chapter, index) of readingExperience.bookChapterList"
            v-bind:key="index"
            :title="chapter.chapterTitle"
            :number="chapter.chapterNumber"
          ></br-index-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import BrIndexItem from "./BrIndexItem";
export default {
  name: "br-book-index-content",
  components: {
    BrIndexItem,
  },
  computed: {
    ...mapState(["readingExperience"]),
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapMutations(["showIndex"]),
    hide() {
      this.showIndex();
    },
  },
};
</script>
